import findIndex from "lodash/findIndex"

export const countriesStatesMap = (propValue, key, componentName, location, propFullName) => {
    if (!Array.isArray(propValue[key])) {
        return new Error(
          `Invalid prop \`${propFullName}\` supplied to \`${componentName}\`. Each key is a country code, with its value an array of states.`
        );
    }
    let isValidArrayElement = s => typeof s === 'string';
    if (!propValue[key].every(isValidArrayElement)) {
        return new Error(
          `Invalid prop \`${propFullName}\` supplied to ${componentName}\`. Element [${findIndex(propValue[key],
            elt => !isValidArrayElement(elt))}`);
    }
    return undefined;
};




// WEBPACK FOOTER //
// ./src/Components/checkout/models/countriesStatesMap.js